'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = UICardHeader;

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _sizes = require('HubStyleTokens/sizes');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _UIAccordionItem = require('../accordion/UIAccordionItem');

var _UIAccordionItem2 = _interopRequireDefault(_UIAccordionItem);

var _UICardSection = require('../card/UICardSection');

var _UICardSection2 = _interopRequireDefault(_UICardSection);

var _AbstractTextElement = require('../elements/AbstractTextElement');

var _AbstractTextElement2 = _interopRequireDefault(_AbstractTextElement);

var _UIFlex = require('../layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

var _tshirtSize = require('../utils/propTypes/tshirtSize');

var _omit = require('../utils/underscore/omit');

var _omit2 = _interopRequireDefault(_omit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var headingForSize = {
  xs: 'span',
  sm: 'h5',
  md: 'h4',
  lg: 'h2',
  xl: 'h1'
};

var Toolbar = _styledComponents2.default.div.withConfig({
  displayName: 'UICardHeader__Toolbar'
})(['flex:1 0 auto;text-align:right;margin-left:', ';'], _sizes.BASE_SPACING_X);

function UICardHeader(props) {
  var className = props.className,
      expanded = props.expanded,
      onExpandedChange = props.onExpandedChange,
      title = props.title,
      titleSize = props.titleSize,
      toolbar = props.toolbar,
      other = _objectWithoutProperties(props, ['className', 'expanded', 'onExpandedChange', 'title', 'titleSize', 'toolbar']);

  var isExpander = typeof onExpandedChange === 'function';
  var shorthandSize = (0, _tshirtSize.toShorthandSize)(titleSize);

  var renderedTitle = isExpander ? _react2.default.createElement(_UIAccordionItem2.default, {
    className: 'private-card__title',
    flush: true,
    onOpenChange: onExpandedChange,
    open: expanded,
    title: title,
    size: shorthandSize
  }) : _react2.default.createElement(
    _AbstractTextElement2.default,
    {
      className: 'private-card__title',
      tagName: headingForSize[shorthandSize]
    },
    title
  );

  return _react2.default.createElement(
    _UICardSection2.default,
    _extends({
      className: (0, _classnames2.default)('private-card__header', className),
      isHeader: true
    }, other),
    _react2.default.createElement(
      _UIFlex2.default,
      { align: 'start', justify: 'between' },
      renderedTitle,
      toolbar && expanded ? _react2.default.createElement(
        Toolbar,
        { className: 'private-card__toolbar private-card__title' },
        toolbar
      ) : null
    )
  );
}

UICardHeader.propTypes = _extends({}, (0, _omit2.default)(_UICardSection2.default.propTypes, ['children']), {
  expanded: _propTypes2.default.bool.isRequired,
  onExpandedChange: _propTypes2.default.func,
  title: _propTypes2.default.node,
  titleSize: _tshirtSize.allSizes,
  toolbar: _propTypes2.default.node
});

UICardHeader.defaultProps = {
  expanded: true,
  titleSize: 'md'
};

UICardHeader.displayName = 'UICardHeader';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/card/UICardHeader.js
// module id = 595
// module chunks = 177